import Datepicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FieldInputProps, FormikProps } from 'formik/dist/types';

export interface FieldProps<V = any, FormValues = any> {
    field: FieldInputProps<V>;
    form: FormikProps<FormValues>;
    minYear?: number;
    maxYear?: number;
}

const DatepickerField = ({ field, form, minYear, maxYear }: FieldProps) => (
    <div>
        <Datepicker
            dateFormat="dd/MM/yyyy"
            {...field}
            selected={field.value}
            onChange={(val) => form.setFieldValue(field.name, val)}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            maxDate={maxYear ? new Date(`${maxYear}-12-31`) : undefined}
            minDate={minYear ? new Date(`${minYear}-01-01`) : undefined}
            autoComplete="off"
        />
    </div>
);
export default DatepickerField;
